export function imageHelper(imageUrl) {
  if (imageUrl === "N/A") {
    return "https://saahiljaffer.com/omdb/white.jpeg";
  }
  return imageUrl;
}
